// project import
import dashboard from './dashboard';
import user from './user';
import exam from './exam';
import common from './common';
import setting from './setting';
// ==============================|| MENU ITEMS ||============================== //
let items = [dashboard, exam, common, user, setting]

const menuItems = {
  items: items
};

export default menuItems;
